import { Component, forwardRef } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SubHeaderComponent } from '@/app/components/common/sub-header/sub-header.component';
import { NavigationComponent } from '@/app/components/common/navigation/navigation.component';
import { TopnavbarComponent } from '@/app/components/common/topnavbar/topnavbar.component';
import { FooterComponent } from '@/app/components/common/footer/footer.component';
import { LayoutDirective } from '../_config/layout.directive';
import { LayoutComponent } from '../layout.component';

@Component({
  selector: 'basic',
  templateUrl: 'basic.component.html',
  styleUrls: ['basic.component.scss'],
  standalone: true,
  imports: [forwardRef(() => SubHeaderComponent), RouterOutlet, LayoutDirective, NavigationComponent, ConfirmDialogModule, TopnavbarComponent, FooterComponent, LayoutComponent, TranslateModule]
})
export class BasicComponent {}
